import { HttpClient } from '@angular/common/http';
import { DestroyRef, Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class HeartbeatService {
  private heartbeatInterval: NodeJS.Timeout | undefined;

  constructor(
    private readonly destroyRef: DestroyRef,
    private readonly http: HttpClient,
  ) {
    this.destroyRef.onDestroy(() => {
      this.stop();
    });
  }

  public start(): void {
    this.sendRequest();

    this.heartbeatInterval = setInterval(
      () => {
        this.sendRequest();
      },
      10 * 60 * 1000,
    );
  }

  public stop(): void {
    clearInterval(this.heartbeatInterval);
  }

  private sendRequest(): void {
    this.http.get(`https://df-sso.scm3d.com/selfclient/extend/${environment.ssoEnv}`).subscribe();
  }
}
